import React from 'react';
import CalendarBase from 'scenes/base/CalendarBase';
import SchedulesDetail from './components/SchedulesDetail';
import SchedulesMain from './components/SchedulesMain';

const Schedules = props => <CalendarBase mainPage={SchedulesMain} detailPage={SchedulesDetail} />;

export default Schedules;
